export const devSFDIGraphqlUrl = process.env.GRAPHQL_SFDI_DEV_URL
export const prodSFDIGraphqlUrl = process.env.GRAPHQL_SFDI_PROD_URL
export const devFABGraphqlUrl = process.env.GRAPHQL_FAB_DEV_URL
export const prodFABGraphqlUrl = process.env.GRAPHQL_FAB_PROD_URL
export const devRobotGraphqlUrl = process.env.GRAPHQL_ROBOT_DEV_URL
export const prodRobotGraphqlUrl = process.env.GRAPHQL_ROBOT_PROD_URL
export const isProduction = process.env.NODE_ENV === 'production'
export const isDevelopment = process.env.NODE_ENV !== 'production'
